<template>
  <div class="dropdown-selection w-150px mr-5">
    <div class="dropdown-selection-head" @click="isModalShow = !isModalShow">
      <button class="btn" style="width: 100%;">
        <span class="mr-3 h5" :class="{ 'ink-01-emphasis--text': isModalShow }"
          >設定錄用狀態</span
        >
        <span v-if="isModalShow">
          <v-icon>arrow_drop_up</v-icon>
        </span>
        <span v-if="!isModalShow">
          <v-icon>arrow_drop_down</v-icon>
        </span>
      </button>
    </div>
    <div class="dropdown-selection-body block w-150px" v-if="isModalShow">
      <div
        class="pl-10px h-48px d-flex align-center selection-item-hover"
        v-for="item in options"
        :key="item"
        @click="setAdmissionStatus(item)"
      >
        <div class="h5 ink-01-emphasis--text h-48px d-flex align-center">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    options: ['錄取', '未錄取', '黑名單'],
    isModalShow: false,
  }),
  methods: {
    setAdmissionStatus(item) {
      this.$emit('set-admission-status', item);
      this.isModalShow = false;
    },
  },
};
</script>

<style></style>
